// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p_mp","footer":"styles_footer__3mLN-","passCodeTooltip":"styles_passCodeTooltip__2esZ9"};